// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"2bf78e3e","453":"54bf6948","850":"424684f0"}[chunkId] + ".chunk.js";
};